import {
  AnnualIntro,
  AnnualQuote,
  AnnualHero,
  Boxes,
  CompactHero,
  FrontPageHero,
  HighlightNumbers,
  SliceAnnualModule,
  SliceArticleCards,
  SliceArticleHero,
  SliceEmbed,
  SliceEmphasisText,
  SliceFeaturedArticles,
  SliceFaq,
  SliceImages,
  SliceIntroText,
  SliceOtherCards,
  SlicePageVideo,
  SliceProductCards,
  SliceQuote,
  SliceRelatedContent,
  SliceTableWithImages,
  SliceText,
  SliceTextCards,
  SliceTextWithImage,
  SliceTextWithLinks,
  SliceTextWithPoints,
  SliceTextWithPullOut,
  SliceTextWithRelated,
  SliceTextWithVideo,
  SliceTextWithWithSideText,
  SliceVideo,
  SubPageHero,
  TableWithLargeText,
  TextWithNumbers,
  Tiles,
  SliceInterestCallout,
} from '@landsbankinn/shared/graphql/prismic/fragments/sliceFragments';

export const allFragments = [
  AnnualIntro,
  AnnualQuote,
  AnnualHero,
  Boxes,
  CompactHero,
  FrontPageHero,
  HighlightNumbers,
  SliceAnnualModule,
  SliceArticleCards,
  SliceArticleHero,
  SliceEmbed,
  SliceEmphasisText,
  SliceFaq,
  SliceFeaturedArticles,
  SliceImages,
  SliceInterestCallout,
  SliceIntroText,
  SliceOtherCards,
  SlicePageVideo,
  SliceProductCards,
  SliceQuote,
  SliceRelatedContent,
  SliceTableWithImages,
  SliceTextCards,
  SliceTextWithImage,
  SliceTextWithLinks,
  SliceTextWithPoints,
  SliceTextWithPullOut,
  SliceTextWithRelated,
  SliceTextWithVideo,
  SliceTextWithWithSideText,
  SliceVideo,
  SubPageHero,
  TableWithLargeText,
  TextWithNumbers,
  Tiles,
  SliceText, // don't order this alphabetically, needs to be in the same chunk as arsskyrsla fragment
];
